export const TOPUP_STATUS_PENDING = 'PENDING'
export const TOPUP_STATUS_PAYMENT_CLAIMED = 'PAYMENT_CLAIMED'
export const TOPUP_STATUS_PROCESSED = 'PROCESSED'
export const TOPUP_STATUS_CANCELLED = 'CANCELLED'